var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgLive = function SvgLive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 37"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.361 31.528a1.5 1.5 0 01-1.06-2.561 14.044 14.044 0 004.141-9.998c0-3.86-1.526-7.465-4.297-10.153a1.5 1.5 0 112.088-2.153 17.003 17.003 0 015.21 12.306 17.03 17.03 0 01-5.02 12.12 1.5 1.5 0 01-1.062.44"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.668 36.876a1.502 1.502 0 01-1.061-2.561 21.5 21.5 0 006.34-15.305c0-5.908-2.337-11.427-6.578-15.54a1.499 1.499 0 112.087-2.154c4.83 4.684 7.49 10.967 7.49 17.694a24.487 24.487 0 01-7.217 17.427 1.495 1.495 0 01-1.06.439M16.38 18.988a8.077 8.077 0 01-8.078 8.077 8.077 8.077 0 110-16.154 8.078 8.078 0 018.078 8.077"
  }))));
};
export default SvgLive;